module.exports = __webpack_public_path__ + "img/topic-active-wdcy.961bd555.png";